<sh-card columns="12">
  <sh-text size="header-2" color="primary">
    {{ 'label.plannedActivities' | translate }}
    <ng-container>
      <span>{{ ticketCountDisplay$ | async }}</span>
    </ng-container>
  </sh-text>
  <api-call-gate
    [apiCall]="serviceTicketsService.getTickets"
    loadingLabel="loading activities.."
  >
    <ng-template #lastSuccessfulData>
      <ng-container
        *ngTemplateOutlet="
          tickets;
          context: { $implicit: nextPlannedActivity$ | async }
        "
      ></ng-container>
    </ng-template>
  </api-call-gate>
</sh-card>
<!-- ticket rendering -->
<ng-template #tickets let-tickets>
  @if (
    (lastOverdueActivity$ | async)?.length > 0 ||
    (nextPlannedActivity$ | async)?.length > 0
  ) {
    <ng-container
      *ngTemplateOutlet="
        (screenLayoutService.desktopAny$ | async) && false
          ? ticketsDesktop
          : ticketsMobile;
        context: {
          $implicit: nextPlannedActivity$ | async,
        }
      "
    ></ng-container>
  }
  @if (
    (lastOverdueActivity$ | async)?.length === 0 &&
    (nextPlannedActivity$ | async)?.length === 0
  ) {
    <div class="empty">
      <sh-icon
        class="view-mode-icon"
        icon="list-viewmode"
        disabled
        size="l"
      ></sh-icon>
      <sh-text class="align-empty-activities-text">{{
        'label.noPlannedActivity' | translate
      }}</sh-text>
    </div>
  }
</ng-template>
<!-- tickets: table version (desktop) NOT USED IN CURRENT DESIGN! -->
<ng-template #ticketsDesktop let-topTickets>
  <sh-table>
    <sh-table-row slot="header">
      <sh-table-head unsortable columns="7">{{
        'label.plannedStart' | translate
      }}</sh-table-head>
      <sh-table-head unsortable columns="7">{{
        'label.plannedEnd' | translate
      }}</sh-table-head>
      <sh-table-head unsortable columns="9"
        >{{ 'label.ticketNumber' | translate }}
      </sh-table-head>
      <sh-table-head unsortable columns="8">{{
        'label.description' | translate
      }}</sh-table-head>
      <sh-table-head unsortable columns="7"
        >{{ 'label.Ticketstatus' | translate }}
      </sh-table-head>
    </sh-table-row>
    @for (ticket of topTickets; track ticket) {
      <sh-table-row>
        <sh-table-cell
          style="height: auto"
          class="ticket-indicator"
          [attr.color]="ticket.statusColor"
          columns="7"
        >
          <sh-text>{{ ticket.plannedStart | localizedDate }}</sh-text>
        </sh-table-cell>
        <sh-table-cell columns="7">
          <sh-text>{{ ticket.plannedEnd | localizedDate }}</sh-text>
        </sh-table-cell>
        <sh-table-cell columns="9">
          <span> {{ ticket.ticketNumber }} </span>
          <sh-icon
            id="copyToClipboard"
            style="cursor: pointer; align-items: baseline; height: auto"
            (click)="clipboard.copyToClipboard(ticket.ticketNumber)"
            aria-label="Copy results to clipboard"
            icon="copy-results-to-clipboard"
            button
            size="s"
          ></sh-icon>
          <sh-tooltip
            label="Copy to Clipboard"
            target="copyToClipboard"
            placement="top"
            variation="short"
          ></sh-tooltip>
        </sh-table-cell>
        <sh-table-cell columns="8">
          <sh-text id="description" #description class="linebreak">
            {{ ticket.description }}</sh-text
          >
          @if (isOverflowing(description)) {
            <sh-tooltip
              label="{{ ticket.description }}"
              target="description"
              placement="top"
              variation="short"
            ></sh-tooltip>
          }
        </sh-table-cell>
        <sh-table-cell columns="7">
          <sh-text> {{ ticket.status }} </sh-text>
        </sh-table-cell>
      </sh-table-row>
    }
  </sh-table>
</ng-template>
<!-- tickets: mobile version (phone & tablet) -->
<!-- maps same template twice for planned and overdue -->
<ng-template #ticketsMobile>
  <ng-container
    *ngTemplateOutlet="
      activities;
      context: {
        $implicit: nextPlannedActivity$ | async,
        title: 'label.nextplannedActivity' | translate,
        buttonLabel: 'All Planned Activities',
        buttonCallback: loadPlannedView,
      }
    "
  ></ng-container>
  @if ((nextPlannedActivity$ | async)?.length === 0) {
    <div class="empty">
      <sh-icon
        size="l"
        class="view-mode-icon"
        icon="list-viewmode"
        disabled
      ></sh-icon>
      <sh-text class="align-empty-activities-text">
        {{ 'label.noFutureActivity' | translate }}</sh-text
      >
    </div>
  }
  <ng-container
    *ngTemplateOutlet="
      activities;
      context: {
        $implicit: lastOverdueActivity$ | async,
        title: 'label.lastoverdueActivity' | translate,
        buttonLabel: 'All Overdue Activities',
        buttonCallback: loadOverdueView,
      }
    "
  ></ng-container>
  @if ((lastOverdueActivity$ | async)?.length === 0) {
    <div class="empty">
      <sh-icon
        size="l"
        class="view-mode-icon"
        icon="list-viewmode"
        disabled
      ></sh-icon>
      <sh-text class="align-empty-activities-text">
        {{ 'label.noOverdueActivity' | translate }}</sh-text
      >
    </div>
  }
</ng-template>
<ng-template
  #activities
  let-activities
  let-title="title"
  let-buttonLabel="buttonLabel"
  let-buttonCallback="buttonCallback"
>
  <sh-text class="last-overdue" size="title-1">{{ title }}</sh-text>
  @if (activities.length > 0) {
    <div class="tickets-mobile">
      @for (ticket of activities; track ticket) {
        <div class="ticket" [attr.color]="ticket.statusColor">
          <section class="mobile-devices-flex">
            <div class="item">
              <sh-text size="body-2" color="secondary"
                >{{ ticket.plannedStart | localizedDate }}
                {{ ticket.plannedStart | localizedTime }}</sh-text
              >
              <span>{{ ticket.ticketType }}</span>
            </div>
            <div class="item">
              <sh-text
                class="ticket-number-text"
                size="body-2"
                color="secondary"
                >{{ 'label.ticketNumber' | translate }}</sh-text
              >
              <span style="display: flex; white-space: nowrap"
                >{{ ticket.ticketNumber }}
                <sh-icon
                  id="copyToClipboard"
                  style="
                    cursor: pointer;
                    align-items: baseline;
                    margin-top: -0.25rem;
                    margin-left: 0.5rem;
                    display: inline;
                  "
                  (click)="clipboard.copyToClipboard(ticket.ticketNumber)"
                  icon="copy-results-to-clipboard"
                  aria-label="Copy results to clipboard"
                  button
                  size="s"
                ></sh-icon>
              </span>
            </div>
          </section>
        </div>
      }
      <div class="button-container">
        <sh-button
          class="activities-button"
          color="secondary"
          size="auto"
          (click)="buttonCallback()"
          [label]="buttonLabel"
          id="target-tickets"
        ></sh-button>
      </div>
    </div>
  }
</ng-template>
